import { useGetContextOrError } from '@/lib/hooks/use-get-context-or-error';

import { context } from './context';

export const useResolvePathFromSlug = () =>
  useGetContextOrError(context, 'PathFromSlug');
